export const ORDER_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2,
  READY: 3,
  OUT: 4,
  DELIVERED: 5,
  CANCELLED: 9,
  SCHEDULED: 10,
}

export const SELLING_TYPES = {
  DELIVERY: 0,
  DINE_IN: 1,
  PICKUP: 2,
  TAKEAWAY: 2,
  CAR_PICKUP: 2,
}

export const PAYMENT_TYPES = {
  ONLINE_PAYMENT: 1,
  CASH: 2,
  PAY_LATER: 3,
}

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.PENDING]: 'order.statuses.pending',
  [ORDER_STATUS.ACCEPTED]: 'order.statuses.accepted',
  [ORDER_STATUS.REJECTED]: 'order.statuses.rejected',
  [ORDER_STATUS.READY]: 'order.statuses.ready',
  [ORDER_STATUS.OUT]: 'order.statuses.out',
  [ORDER_STATUS.DELIVERED]: 'order.statuses.delivered',
  [ORDER_STATUS.CANCELLED]: 'order.statuses.cancelled',
  [ORDER_STATUS.SCHEDULED]: 'order.statuses.scheduled',
}

export const SELLING_TYPES_LABELS = {
  [SELLING_TYPES.DELIVERY]: 'selling-types.types.delivery',
  [SELLING_TYPES.DINE_IN]: 'selling-types.types.dine_in',
  [SELLING_TYPES.PICKUP]: 'selling-types.types.car_pickup',
  '-1': 'orders.takeaway',
}

export const PAYMENT_TYPES_LABELS = {
  [PAYMENT_TYPES.ONLINE_PAYMENT]: 'payment.credit-card',
  [PAYMENT_TYPES.CASH]: 'payment.cash',
  [PAYMENT_TYPES.PAY_LATER]: 'payment.pay-later',
  '': 'cart.pay-later',
}

export const PAYMENT_STATUS_LABELS = {
  0: 'order.unpaid',
  false: 'order.unpaid',
  1: 'order.paid',
  true: 'order.paid',
}

export const ORDER_STATUS_COLORS = {
  [ORDER_STATUS.PENDING]: '#ADEA6C',
  [ORDER_STATUS.ACCEPTED]: '#95BAE4',
  [ORDER_STATUS.REJECTED]: '#F9A8AE',
  [ORDER_STATUS.READY]: '#7ea8dc',
  [ORDER_STATUS.OUT]: '#5f8bd2',
  [ORDER_STATUS.DELIVERED]: '#4b71c5',
  [ORDER_STATUS.CANCELLED]: '#F9A8AE',
  [ORDER_STATUS.SCHEDULED]: '#334475',
}

export const SELLING_TYPES_COLORS = {
  [SELLING_TYPES.DELIVERY]: '#ADEA6C',
  [SELLING_TYPES.DINE_IN]: '#95BAE4',
  [SELLING_TYPES.PICKUP]: '#F9A8AE',
  '-1': '#334475',
}

export const PAYMENT_TYPES_COLORS = {
  [PAYMENT_TYPES.ONLINE_PAYMENT]: '#95BAE4',
  [PAYMENT_TYPES.CASH]: '#ADEA6C',
  [PAYMENT_TYPES.PAY_LATER]: '#F9A8AE',
  '': '#F9A8AE',
}

export const PAYMENT_STATUS_COLORS = {
  0: '#F9A8AE',
  false: '#F9A8AE',
  1: '#95BAE4',
  true: '#95BAE4',
}
